export default __webpack_public_path__ + "static/O0017-9c23514a5d3478cfed939167f3158c08.png";